import {Injectable} from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class CommonConstant{
  quickQuoteDefaultClientId = '639e2394-a697-4472-86c6-64bdbf50110f';
  borrowerScreenTimeDelay = 2000;
  urlaScreenTimeDelay = 2000;
  taxonomyScreenTimeDelay = 100;
  TaxonomyGroup = {
    LoanApplicationGroup: 101,

  }
  UserPermissionNounType ={
    Customer : 101,
    Partner : 102,
    ReferralPartner : 103,
    EnterpriceAdmin : 104,
    AdminSettings : 105,
    Client : 106,


  }
  UserPermissionVerbType ={
    Edit : 101,
    View : 102,
    Delete : 103,
    Add : 104,
    UserRole: 105,
  }
  AUSType ={
    DU : 101,
    GUS : 102,
    LoanPass : 103,

  }
  LoanApplicationSaveFunctionType ={
    RegisterLoan : 101,
    InitialSubmit : 102,

  }
  PPEScreenMode ={
    Landscape : 101,
    Portrait : 102,

  }
  ProductType ={
    CreditLine : 101,
   }

  UserRoleName ={
    LoanOfficer : 'LOAN_OFFICER',
    Borrower : 'Borrower',
    Enterprise_Admin : 'ENTERPRISE_ADMIN',
    CLIENT_ADMIN : 'CLIENT_ADMIN',
    LOAN_OPENER : 'LOAN_OPENER',
    LOAN_OFFICER_ASSISTANT : 'LOAN_OFFICER_ASSISTANT',
    LOAN_ASSISTANT : 'LOAN_ASSISTANT',
    LOAN_PROCESSOR :'LOAN_PROCESSOR',
    LOAN_UNDERWRITER : 'LOAN_UNDERWRITER',
    LOAN_JUNIOR_UNDERWRITER :'LOAN_JUNIOR_UNDERWRITER',
    CLOSER : 'CLOSER',
    FUNDER : 'FUNDER',
    POST_CLOSER : 'POST_CLOSER',
    JUNIOR_PROCESSOR : 'JUNIOR_PROCESSOR',
    DOC_DRAWER : 'DOC_DRAWER',
    LOCK_DESK : 'LOCK_DESK',
    DISCLOSURE_DESK : 'DISCLOSURE_DESK',
    PURCHASER : 'PURCHASER',
    SECONDARY : 'SECONDARY',
    SHIPPER : 'SHIPPER',
    SERVICING : 'SERVICING',
    LOAN_OFFICER_EXTERNAL : 'LOAN_OFFICER_EXTERNAL',
    PROCESSOR_EXTERNAL : 'PROCESSOR_EXTERNAL',
    SECONDARY_EXTERNAL : 'SECONDARY_EXTERNAL',
    AccountExective : 'ACCOUNT_EXECUTIVE',
    AccountManager : 'ACCOUNT_MANAGER',
   }
  ApplicantType={
    Borrower : 101,
  }
  LoanDocumentStatusType={
    Archived : 101,
    Locked : 102,
    UnLocked : 103,
  };
  CreateNewLoanType={
    Loan : '101',
    Lead : '102',
  };
  TransactionType = {
    Purchase : 101,
    Refinance : 102,
    No_Cash_Out_Refinance : 103,
    Construction : 104,
  };
  RefinanceType = {
    CashOutRefinance : 101,
    NoCashOutRefinance : 102,

  };
  LoanPurposeType = {
    Purchase : 101,
    CashOutRefi : 102,
    No_Cash_Out_Refinance : 103,

  };
  SessionStorageKey ={
    LH_ID_TOKEN :'LH-ID-TOKEN',
    APP_USER :'APP-USER',
    TAXONOMIES : 'taxonomies',
    LOAN_SELECTED : 'loanId',
    SELECTED_QUOTE : 'SelectedQuote',
    PRICING_RESULTS : 'PricingResults',

  }
  MortgageType = {
    QM : 101,
    NONQM : 105,

  };
  LoanEligibilityType = {
    Eligible : 101,
    InEligible : 102,

  };
   occupancy = {
    OWNER_OCCUPIED: 101,
    SECOND_HOME: 102,
    INVESTMENT: 103
  };

  BorrowerActions = {
    BorrowerAddressInfo : 101,
    BorrowerAddressInfoEdit : 102,
    BorrowerAssets : 103,
    BorrowerAssetsEdit: 104,
    BorrowerDashboard : 105,
    BorrowerDashboardLoan : 106,
    BorrowerDeclaration : 107,
    BorrowerDeclarationEdit : 108,
    BorrowerDeclaration1 : 109,
    BorrowerDeclaration1Edit : 110,
    BorrowerDemographics : 111,
    BorrowerDemographicsEdit: 112,
    BorrowerEmploymentIncomePage1 : 113,
    BorrowerEmploymentIncomePage1Edit : 114,
    BorrowerEmploymentIncomePage2 : 115,
    BorrowerEmploymentIncomePage2Edit : 116,
    BorrowerEmploymentIncomePage3 : 117,
    BorrowerEmploymentIncomePage3Edit : 118,
    BorrowerMilitaryService : 119,
    BorrowerMilitaryServiceEdit :120,
    BorrowerREO : 121,
    BorrowerREOEdit : 122,
    BorrowerSubjectProperty : 123,
    BorrowerSubjectPropertyEdit : 124,
    LoanPurposeEdit : 125,
    BorrowerLoanDocumentEdit:126,
    BorrowerLiability: 127,
    BorrowerLiabilityEdit: 128,
    BorrowerInfo : 129,
    BorrowerInfoEdit : 130
  };
  SessionConstants ={
    PricingResults : 'PricingResults',
    SelectedRateOption : 'SelectedRateOption',
    SelectedQuote : 'SelectedQuote',
    SelectedProgramme :'SelectedProgramme',
    SelectedStipulations : 'SelectedStipulations',
  };

  LockStatusType = {
    float: 101,
    locked: 102,
    pending: 103,
    expired : 104,
  };
  LockStates = {
    RequestRateLock: 101,
    Locked: 102,
    RequestReLock : 103,
  };
  LockStatesType = {
    RequestRateLock: 101,
    AcceptLock: 102,
    Unlock : 104,
    RequestLockExtension : 107,
    AcceptLockExtension : 108,
    RequestNewAdjustment : 110,
    AcceptNewAdjustment : 111,
    RejectLockRequest : 112,
    CommentsChange : 113,
  };
  TaxInsuranceEscrowWaiver ={
    Yes : 102,
    No : 101,
  };
  YesNo ={
    Yes : 101,
    No : 102,
  };
  LoanAppUserRoles ={
    LockDesk : 'Lock Desk',
    LoanOfficer : 'Loan Officer',
    EnterpriseAdmin : 'Enterprise Admin'
  };
  LoanAppUserPermission ={
    AcceptLocksAndExtensions : 'Accept Locks and Extensions Edit',

  };
  NavigationMenuItem ={
    URLA : 'Loan Application',
    overview : 'Overview',
    LoanSummary : 'Underwriting Conditions',
    UpdateLoanData : 'Update Loan Data',
    ReIssueCredit :'New / Re-Issue Credit',
    Credit :'Credit',
    LockLoan : 'Request Rate Lock',
    ExtendLock : 'Extend Lock',
    Actions : 'Actions',
    LoanPipeline :'Loan Pipeline',
    ViewCredit :'View Credit Report',
    OrderNewCredit :'Order Credit',
    Notes : 'Notes',
    RegisterLoan : 'Register Loan',
    LoanDocuments : 'Document Manager',
    Disclosure : 'Disclosure',
    DisclosureFees : 'Charges and Fees',
    DisclosureServiceProviders : 'Service Providers',
    loanAdditional : 'Loan Additional',
    generalTracking : 'General Tracking',
    underwriting : 'Underwriter',
    hmda : 'HMDA',
    appraisalInformation : 'Appraisal Information',
    governmentData : 'Government Data',
    agentAssignment : 'Assignments',
    loanTracking :'Loan Tracking',
    dealDeskManager : 'Deal Desk Manager',
    disclosureDesk : 'Disclosures',
    appraisalDesk : 'Appraisal',
    loanProcessor : 'Loan Processor',
    accountManager : 'Account Manager',
     complianceReview : 'Compliance Review',
    closing : 'Closer',
    funding : 'Funder',
    postClosing : 'Post Closer',
    shipping : 'Shipping',
    reconciliation : 'Reconciliation',
    services : 'Actions',
    qualityControl :'Compliance',
    secondary :'Secondary',
    otherActions : 'Other Actions',
    orderMortgageInsurance : 'Order Mortgage Insurance',
    orderTitle : 'Order Title',
    loanDates : 'Loan Dates',
    compensation : 'Compensation',



  };
  LoanStatusType = {
    Update :100,
    NewLoan :200,
    Prospect : 101,
    Registered : 102,
    ReceivedIncomplete:104,
    LoanSubmitted :103,
    PendingDisclosure:105,
    DisclosureSentToBorrower:106,
    DisclosureExcecuted:107,
    AppraisalOrderd:108,
    AppraisalScheduled:109,
    InitialSubmission:110,
    ConditionalApproval:111,
    ComplianceReviewDeficient:112,
    ConditionsSubmitted:113,
    FinalApproval:114,
    ComplianceReview:115,
    ComplianceConditionsSubmitted:116,
    ClearToClose:117,
    PendingDocs:118,
    PendingFunding:119,
    Funded:120,
    InPostClosing:121,
    ShippedToInvestor:122,
    SoldToInvestor:123,
    ConditionsReview:125,


  };
  LoanStatusActionType = {
    Prospect : 101,
    Registered : 102,
    ReceivedIncomplete:104,
    LoanSubmitted :103,
    PendingDisclosure:105,
    DisclosureSentToBorrower:106,
    DisclosureExcecuted:107,
    AppraisalOrderd:108,
    AppraisalScheduled:109,
    InitialSubmission:110,
    ConditionalApproval:111,
    ComplianceReviewDeficient:112,
    ConditionsSubmitted:113,
    FinalApproval:114,
    ComplianceReview:115,
    ComplianceConditionsSubmitted:116,
    ClearToClose:117,
    PendingDocs:118,
    PendingFunding:119,
    Funded:120,
    InPostClosing:121,
    ShippedToInvestor:122,
    SoldToInvestor:123,



  };
  LoanDateType = {
    ScheduleClosing : 101,
    EstimatedClosing : 102,
    EstimatedFunding : 103,
    SurveyDate : 104,
    ApplicationTaken : 105,

   };
  EngineProductStatus = {
    Approved : 'approved',
    Rejected : 'rejected',

  };
  LoanOperationType = {
    save : 101,
    fetch : 102,
    sendCreditRequest : 103,
    LoanDatesUpdate : 110,

  };
  ValidationMessageType = {
    Info : 101,
    Error : 102,
    Warning : 103,

  };
  ChannelType = {
    Retail : 101,
    Wholesale : 102,
    NDC : 103,
    Correspondent : 104,

  };
  ValidationCategoryType = {
    Borrower : 101,
    Credit : 102,
    DealData : 103,
    Assets : 104,
    Liability : 105,
    REO : 106,
    Property : 107,
    Declaration : 108,
    Demographics : 109,
    Income: 110,
    Employment:111,
    All : 112,
    URLA_ONLY : 113,
    InterviewerDetail : 114,
    LoanData : 115,
    AgentAssignment : 116,


  };
  ExternalServiceType ={
    PricingEngine : 102,
    LOS : 101,
    Credit : 104,
    DocumentService : 105,
  };
  ServicePaymentCreditMethodType ={
    AmericanExpress : 101,

  };
  CreditReportRequestActionType ={
    Reissue : 103,
    Submit : 107,
    Update : 108,
    Upgrade : 109,


  };
  CreditPullStatus = {
    Success : 'Success',
    Error : 'Error',

  };
  UserCredentialType ={
    User : 101,
    Company : 102,
  };
  LicenseLevelType ={
    Broker : 101,
    Branch : 102,
    Client : 103,
  };
  NotificationMessages = {
    msg001 :'Operation Completed Successfully...',
    msg002 : 'Operation Completed UnSuccessfully...',
    msg003 :'Borrower\'s Social Security number or current address is invalid. Please fix it before ordering credit.',
    msg004 : 'LOS Operation Failed...',
    msg005 : 'Email already taken. please use a different email...',
    msg006 : 'All PTD Conditions must have either a document submitted or a document not applicable checkbox checked.',
    msg007 : 'Compensation may not be changed once the loan has been locked. To change the compensation on this loan, please email ratelocks@goloanhouse.com for assistance',
    msg008 : 'Please select at least one role for the user',
  };
  LoanAppUserRoleNames = {
    EnterpriseAdmin : 'Enterprise Admin',
    ClientAdmin : 'CLIENT_ADIN',

  };
  TaxonomyType = {
    PermissionCategoryType :'PermissionCategoryType',
  };
  StipulationCategoryType = {
    PTD : 101,
    InternalCompliance : 104,
   };
  StipulationLoanStatusCategoryType = {
    PTD : 101,
  };
  StipulationType = {
    PPE_Condition : 121,
  };
  QQOccupancyType ={
    PrimiarResidence : 101,
    SecondaryResidence : 102,
    Investment : 103,
  };
  QQEmploymentType ={
    WageEarner : 101,
    W2_CommissionEmployee : 102,
    Contract_1099 : 103,
    self_employed : 104,
    retired : 105,
  };
  QQIncomeDocType ={
    DSCR : 101,
    FullDoc : 102,
    BankStatement : 103,
    1099 : 104,
  };
  QQPropertyInfoType ={
    Condominium : 102,
  };
  EmploymentStatusType ={
    Current : 101,
    Previous : 102,

  };
  LoanQualificationType ={
    QM : 101,
    NonQM : 102,
  };
  LoanPositionType ={
    First : 101,
    Second : 102,
  };
  YesNoType ={
    Yes : 101,
    No : 102,
  };
  DisclosureSectionType ={
    A_Origination_Charges : 101,
    B_Services_You_Cannot_Shop_For : 102,
    C_Services_You_Can_Shop_For :103,
    E_Taxes_And_Other_Government_Fees:104,
    F_Prepaids:105,
    G_Initial_Escrow_Payment_At_Closing:106,
    H_Other:107,
    I_totalOtherCost:112,
    J_totalClsoingCost:113,

  };
  DisclosureCalcType ={
    Amount : 101,
    Appraisal_Value : 102,
    Loan_Amount :103,
    Purchase_price:104,
    Total_Loan_Amont:105,


  };
  MortgageLoanType = {
    Conventional : 101,
    FHA : 102,
    VA : 103,
    USDA : 104,
    NQM : 105,
    DSCR : 106,

  };
  ServiceProviders = {
    AppraisalProvider : 101,
    Appraiser : 102,
    ClosingAgent : 113,
    HazardInsurance : 132,
    RealEstateSeller : 133,
    RealEstateBuyer : 134,
    SettlementAgentCompany : 135,
    TitleCompany : 136,
    TitleInsurance : 137,
    PropertySeller : 138,
    SettlementAgentContact : 139,
    InstrumentPreparedBy : 140,
    FHASponsor : 141,
    CounsellingAgency : 142,
    EducationAgency : 143,

  };
  CompensationType = {
    Percentage : 101,
    Fixed : 102,
 };
  DisclosurePaidToType ={
    ThirdPartyProvider : 107,
  };
  DisclosureBSectionType = {
    MIInitialPremium : 103,
    MIInitialPremiumCash : 104,
    MIUpfrontPremium : 105,
    MIUpfrontPremiumCash : 106,
    USDARuralDevelopmentGuaranteeFee : 107,
    USDARuralDevelopmentGuaranteeFeeCash : 108,
    VAFundingFee : 109,
    VAFundingFeeCash : 110,

  };
  WorkQueueType = {
     LoanProcessor : 101,
     AccountManager : 102,
     DisclosureDesk : 103,
     AppraisalDesk : 104,
     Underwriter : 105,
     QualityControl : 106,
     Closer : 107,
     Funder : 108,
     PostCloser : 109,
  };

  QQoccupancy = {
    OWNER_OCCUPIED: 101,
    SECOND_HOME: 102,
    INVESTMENT: 103
  };
  QQemployment = {
    WORK_FOR_COMPANY: 101,
    SELF_EMPLOYED: 102,
    RETIRED: 103
  };
  QQtransaction = {
    PURCHASE: 101,
    REFINANCE: 102,

  };
  LoanCompensationPaidType = {
    BorrowerPaid: 101,
    LenderPaid: 102,

  };
  MarginLevelType = {
    Corporate: 101,
    Company: 102,
    LoanOfficer: 103,

  };
  UserRoleType = {
    Borrower: 101,
    Enterprise: 102,
    Client: 103,
    Branch: 104,

  };






}
